module.exports = __webpack_public_path__ + "img/header-weddingRingsStackingRings@2x.e752e63.jpg";